/** Logo oficial — colocar el PNG en ecommerce/public/brand/ */
export const BRAND_LOGO_URL = '/brand/logo-alarcom.png';
export const BRAND_LOGO_ALT = 'Grupo Alarcom';
